const isContactFormVisible = (state = false, action) => {
  switch (action.type) {
      case 'SET_CONTACT_FORM_VISIBLE':
          return action.visible
      default:
          return state
  }
}

export default isContactFormVisible;